import React, { useState } from 'react';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { predictWithGoogleAI } from '../../../utils/googleAI.js';
import { buildSablonGelistirPrompt, parseSablonGelistirYaniti } from '../../../prompts/sablonPrompts.js';

const AIEnhancer = ({ icerik, onEnhance, tumEtiketler, tumKanunMaddeleri }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateEnhancement = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const prompt = buildSablonGelistirPrompt({ icerik, tumEtiketler, tumKanunMaddeleri });
      const aiResponse = await predictWithGoogleAI(prompt);
      const { ozet, baslik, etiketler, kanunMaddeleri } = parseSablonGelistirYaniti(aiResponse);

      onEnhance({ ozet, baslik, etiketler, kanunMaddeleri });
    } catch (err) {
      setError('AI geliştirmesi sırasında bir hata oluştu. Lütfen tekrar deneyin.');
      console.error('AI geliştirme hatası:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex justify-end">
      <button
        type="button"
        onClick={generateEnhancement}
        disabled={isLoading}
        className={`text-gray-500 hover:text-blue-600 transition-colors duration-200 ${isLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
        title={isLoading ? 'İşleniyor...' : 'AI ile Geliştir'}
      >
        <SparklesIcon className={`h-6 w-6 ${isLoading ? 'animate-pulse' : ''}`} />
      </button>
      
      {error && <p className="text-red-500 mt-2 text-sm">{error}</p>}
    </div>
  );
};

export default AIEnhancer;
